export default "/react/logoAmberData-e4ea01de.png";